
function adjustSliders() {
   var sliders = document.getElementById('custom-collection-lreo');
   if (sliders) {
      var flkty = new Flickity(sliders, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
             cellAlign: 'left'
      });
      sliders.classList.add('spring-slider-visible');
   }
}
adjustSliders();

function reviewSliders() {
   var slidersreview = document.getElementById('custom-reviews-slider');
   if (slidersreview) {
      var flkty = new Flickity(slidersreview, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false
      });
      slidersreview.classList.add('spring-slider-visible');
   }
}
reviewSliders();

// 定义 adjustSlidersP 函数
function adjustSlidersP() {
    var slidersP = document.getElementById('product-ementary-slider');
    if (slidersP) {
        var flkty = new Flickity(slidersP, {
            wrapAround: true,
            fullscreen: true,
            contain: true,
            pageDots: false,
            cellAlign: 'left'
        });
        slidersP.classList.add('spring-slider-visible');
    }
}
adjustSlidersP();
// 监听 product-recommendations 内部元素变化
var recommendationsContainer = document.querySelector('product-recommendations');
if (recommendationsContainer) {
    var observers = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // product-ementary-slider 已经更新，执行 adjustSlidersP
                adjustSlidersP();
            }
        });
    });
    var observerConfig = { childList: true };
    observers.observe(recommendationsContainer, observerConfig);
}